import * as v from 'valibot';

export const offeringFormSchema = v.object({
  name: v.pipe(v.string(), v.minLength(1, 'Offering name is required')),
});

export type OfferingFormValues = v.InferOutput<typeof offeringFormSchema>;
